import { throwError } from "@lib/throwError";
import { del, get, post, put } from "@/services/axiosUitils";
import {
  AssignPermissionPayload,
  CreateRolePayload,
  Role,
  UpdateRolePayload,
} from "@/utils/types/tenantPermissions";

const rolesBase = "/tenant-permissions/roles/";

interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

class TenantRoleService {
  listRoles = async (
    page = 1,
    pageSize = 20
  ): Promise<PaginatedResponse<Role>> => {
    return await get<PaginatedResponse<Role>>(rolesBase, {
      params: { page, page_size: pageSize },
    });
  };

  getRoleById = async (id: string): Promise<Role> => {
    if (!id) {
      throwError("ID is required", "TenantRoleService");
    }
    return await get<Role>(`${rolesBase}${id}/`);
  };

  createRole = async (payload: CreateRolePayload): Promise<Role> => {
    if (!payload) {
      throwError("Payload is required", "TenantRoleService");
    }
    return await post<Role>(rolesBase, payload);
  };

  updateRole = async (
    id: string,
    payload: UpdateRolePayload
  ): Promise<Role> => {
    if (!id || !payload) {
      throwError("ID and payload are required", "TenantRoleService");
    }
    return await put<Role>(`${rolesBase}${id}/`, payload);
  };

  deleteRole = async (id: string): Promise<any> => {
    if (!id) {
      throwError("ID is required", "TenantRoleService");
    }
    return await del(`${rolesBase}${id}/`);
  };

  assignPermissionToRole = async (
    roleId: string,
    payload: AssignPermissionPayload
  ): Promise<any> => {
    if (!roleId || !payload) {
      throwError("Role ID and payload are required", "TenantRoleService");
    }
    return await post(`${rolesBase}${roleId}/assign_permission/`, payload);
  };
}

const instance = new TenantRoleService();
export default instance;
